var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAnyTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 29,
    viewBox: "0 0 43 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#8E8E93",
    strokeWidth: 2,
    d: "M42 10.645V2.929C42 1.864 40.852 1 39.437 1H3.563C2.147 1 1 1.864 1 2.929v7.716c2.819 0 4.366 1.736 4.366 3.858S3.819 18.36 1 18.36v7.71C1 27.136 2.148 28 3.563 28h35.874C40.852 28 42 27.136 42 26.071v-7.71c-2.819 0-4.366-1.736-4.366-3.858 0-2.124 1.547-3.858 4.366-3.858z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAnyTicket);
export default __webpack_public_path__ + "static/media/ico-any-ticket.474e6492.svg";
export { ForwardRef as ReactComponent };